import { useRef } from 'react';
import defaultOptionDescription from '../../internal/components/option/option-announcer';
export var useAnnouncement = function (_a) {
    var announceSelected = _a.announceSelected, highlightedOption = _a.highlightedOption, parentMap = _a.parentMap, selectedAriaLabel = _a.selectedAriaLabel, renderHighlightedAriaLive = _a.renderHighlightedAriaLive;
    var prevAnnouncedGroup = useRef(undefined);
    var message = '';
    if (highlightedOption) {
        var group = parentMap.get(highlightedOption);
        var groupToAnnounce = group !== prevAnnouncedGroup.current ? group : undefined;
        prevAnnouncedGroup.current = group;
        message = (renderHighlightedAriaLive || defaultOptionDescription)(highlightedOption.option, groupToAnnounce === null || groupToAnnounce === void 0 ? void 0 : groupToAnnounce.option);
        if (announceSelected && !renderHighlightedAriaLive) {
            message = (selectedAriaLabel ? selectedAriaLabel + ' ' : '') + message;
        }
    }
    return message;
};
